import * as React from "react";
import "./SignedPdfItem.scss";
import moment from "moment";
import { Icon } from "@coverme/icons";
import { useState } from "react";

export const SignedPdfItem = ({ signedPdfObject, onDownload }) => {
    const [documentDropDownOpen, setDocumentDropDownOpen] = useState(false);
    let displayMessage = "";
    function toggleDocumentList() {
        setDocumentDropDownOpen(!documentDropDownOpen);
    }
    if (signedPdfObject.status === "Completed") {
        if (signedPdfObject.documentsInBatch?.length === 1) {
            displayMessage =
                "Completed on " +
                moment(signedPdfObject.signatureCollectionDate).format("MM.DD.YYYY") +
                ", " +
                signedPdfObject.documentsInBatch[0];
        } else if (signedPdfObject.documentsInBatch?.length > 1) {
            displayMessage = "Completed on " + moment(signedPdfObject.signatureCollectionDate).format("MM.DD.YYYY");
        }
    } else if (signedPdfObject.status === "Expired") {
        if (signedPdfObject.documentsInBatch?.length === 1) {
            displayMessage =
                "Expired on " +
                moment(signedPdfObject.signatureCollectionDate).format("MM.DD.YYYY") +
                ", " +
                signedPdfObject.documentsInBatch[0];
        } else if (signedPdfObject.documentsInBatch?.length > 1) {
            displayMessage = "Expired on " + moment(signedPdfObject.signatureCollectionDate).format("MM.DD.YYYY");
        }
    } else {
        if (signedPdfObject.documentsInBatch?.length === 1) {
            displayMessage =
                "Sent on " +
                moment(signedPdfObject.initiatedDate).format("MM.DD.YYYY") +
                ", " +
                signedPdfObject.documentsInBatch[0];
        } else if (signedPdfObject.documentsInBatch?.length > 1) {
            displayMessage = "Sent on " + moment(signedPdfObject.initiatedDate).format("MM.DD.YYYY");
        }
    }

    return (
        <div className="signedPdfItem">
            <div className="signedPdfItem__info">
                <div className="signedPdfItem__info-item">
                    <span className="p-regular">{displayMessage}</span>
                </div>
                {signedPdfObject.status === "Completed" && (
                    <div className="signedPdfItem__info-item">
                        <button
                            className="download-button"
                            onClick={onDownload?.bind(this, signedPdfObject?.documentId)}
                        >
                            <Icon icon={"download"} color={"black"} height={20} width={20} />
                        </button>
                    </div>
                )}
            </div>
            {signedPdfObject?.documentsInBatch?.length > 1 && (
                <div>
                    <div>
                        <span style={{ marginRight: "10px", marginLeft: "10px" }} className="p-regular">
                            View Documents{" "}
                            <button style={{ border: "None" }} onClick={toggleDocumentList}>
                                {documentDropDownOpen === true ? "(-)" : "(+)"}
                            </button>
                        </span>
                    </div>
                    {documentDropDownOpen === true && (
                        <div style={{ marginRight: "10px", marginLeft: "20px" }}>
                            {signedPdfObject?.documentsInBatch?.map(x => (
                                <div>
                                    <p>{x}</p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
